import apiService from "./apiService";
import AppConstants from "../appConstants";

class MediaService {
    getLatestMedia(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_PLAYLIST_LATEST_MEDIA, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
}

export default new MediaService();
